import { selectDevicesFields, selectSelectedDeviceFields } from 'entities/device/lib';
export const field_for_device_maintenance = selectDevicesFields([
    'id',
    'name',
    'device_type',
    'maintenances',
    'work_state',
    'capabilities',
    'installation_state',
]);
export const selected_device_for_device_maintenance = selectSelectedDeviceFields([
    'id',
    'name',
    'device_type',
    'maintenances',
    'work_state',
    'capabilities',
    'installation_state',
]);
